/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import dynamic from "next/dynamic";

import ButtonNew from "components/atoms/ButtonNew";
import Img from "components/atoms/Img";
import SocialShare from "components/molecules/SocialShare/SocialShare";
import Faqs from "components/organisms/Faqs";
const SsicUK = dynamic(
  () => import("components/templates/common/ssic-code-search/ssic-uk"),
  { ssr: false }
);

import FormDownloadModal from "../FormDownloadModal";

import styles from "./Index.module.scss";

export default function MainContent({ data, dataJson, screen }) {
  const [isShow, setIsShow] = useState(false);
  const [searchkey, setSearchKey] = useState("");
  const [showFormDownload, setShowFormDownload] = useState(false);

  useEffect(() => {
    const iconList = document.querySelectorAll(".fa-check");

    if (iconList) {
      iconList.forEach((icon) => {
        // eslint-disable-next-line no-param-reassign
        icon.innerHTML =
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" className=""></path></svg>';
      });
    }

    const iconSearch = document.querySelectorAll(".fa-search");

    if (iconSearch) {
      iconSearch.forEach((icon) => {
        // eslint-disable-next-line no-param-reassign
        icon.innerHTML =
          '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>';
      });
    }

    const loadIcon = document.querySelectorAll(".bi-loader");

    if (loadIcon) {
      loadIcon.forEach((icon) => {
        // eslint-disable-next-line no-param-reassign
        icon.innerHTML =
          '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path></svg>';
      });
    }
  }, []);

  useEffect(() => {
    const inputField = document.querySelectorAll(".search_uksic");
    const searchBtn = document.querySelectorAll(".search_btn");

    if (searchBtn[0]) {
      searchBtn[0].addEventListener("click", () => {
        setSearchKey(inputField[0].value);

        if (inputField[0].value === "") {
          setIsShow(false);
        } else {
          setIsShow(true);
        }
      });
    }
    if (inputField[0]) {
      inputField[0].addEventListener("keypress", (event) => {
        if (event.key === "Enter") {
          setSearchKey(inputField[0].value);
          if (inputField[0].value === "") {
            setIsShow(false);
          } else {
            setIsShow(true);
          }
        }
      });
    }
    if (document.getElementById("sic_uk")) {
      ReactDOM.render(
        <>{isShow && <SsicUK searchValue={searchkey} />}</>,
        document.getElementById("sic_uk")
      );
    }
  }, [isShow, searchkey]);

  return (
    <div className={styles.postsContent}>
      <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
      {dataJson &&
        screen !== "DESKTOP" &&
        dataJson.guide_link &&
        dataJson.guide_link.forEach((item, index) => {
          if (item.chosenPost === data.databaseId) {
            return (
              <div
                key={index}
                className="group mt-[30px] rounded-xl  bg-bbc-gradient-liner3 px-3 py-10"
              >
                <div className="flex w-full justify-center">
                  <Img {...item.img} alt="place-holder" />
                </div>
                <p className="text-center text-2xl font-semibold text-bbc-white">
                  {item.title}
                </p>
                <p className="mt-4 text-center text-bbc-white">
                  {item.description}
                </p>
                {item.link ? (
                  <div className="mt-6 flex w-full justify-center">
                    <ButtonNew
                      as="a"
                      href={item.link}
                      className="w-full rounded-full bg-bbc-primary py-2 text-center capitalize  !text-bbc-white"
                      target="_blank"
                    >
                      Try now
                    </ButtonNew>
                  </div>
                ) : (
                  <div className="mt-6 flex w-full justify-center">
                    <ButtonNew
                      onClick={() => setShowFormDownload(true)}
                      className="w-full rounded-full bg-bbc-primary py-2 text-center capitalize !text-bbc-white "
                    >
                      Unlock guide
                    </ButtonNew>
                    <FormDownloadModal
                      typeFormDownload={item.dataForm}
                      show={showFormDownload}
                      onHide={() => setShowFormDownload(false)}
                    />
                  </div>
                )}
              </div>
            );
          }
        })}
      {data?.faqs && data?.faqs?.faqs && (
        <div className="mt-10 mb-6">
          <Faqs
            data={data.faqs.faqs}
            buttonClass="lg:px-5 font-normal lg:font-medium !text-base lg:!text-lg"
            panelClass="lg:px-5"
          />
        </div>
      )}
      <div className="mt-10 italic">
        <p style={{ fontSize: "13px", lineHeight: "20px" }}>
          <span className="font-semibold">Disclaimer: </span>While BBCIncorp
          strives to make the information on this website as timely and accurate
          as possible, the information itself is for reference purposes only.
          You should not substitute the information provided in this article for
          competent legal advice. Feel free to contact BBCIncorp’s customer
          services for advice on your specific cases.
        </p>
      </div>
      <SocialShare
        iconWidth={30}
        iconHeight={30}
        title="Share this article"
        titleClass={"block"}
      />
    </div>
  );
}
